import Vue from 'vue'
import VueMq from 'vue-mq'

Vue.use(VueMq, {"defaultBreakpoint":"default","breakpoints":{"sm":600,"md":900,"lg":1200,"xl":1600,"hd":Infinity}})
